import React from 'react';
import DirectoryCardBase from './DirectoryCardBase';
import { Text, VStack } from '@chakra-ui/react';
import RequestAProviderSessionModalTrigger from '@/modules/user/RequestATherapySessionModalTrigger';
import colors from '@/theme/colors';
import { TProviderApi } from '@/types/Provider.types';
import { EMPTY_STRING_VALUE } from '@/constants/stringVars';
import { displayCapitalizedUnderscoredString } from '@/utils/stringUtils';

const ACTION_BUTTON_WIDTH = '120px';

type Props = {
  provider: TProviderApi;
};

const MYOProviderDirectoryCard = ({ provider }: Props) => {
  const name = `${provider.first_name} ${provider.last_name}`;

  const statesFormatted = provider?.locations?.map((location) => `${location.city}, ${location.state}`);
  const specializationsFormatted = provider?.specialities
    ? provider?.specialities
        .map((specialty) => (specialty.includes('+') ? specialty : displayCapitalizedUnderscoredString(specialty)))
        .join(', ')
    : EMPTY_STRING_VALUE;
  const availabilityFormatted = provider?.availability ?? EMPTY_STRING_VALUE;

  return (
    <DirectoryCardBase
      name={name}
      pictureUrl={provider.profile_photo ?? undefined}
      pictureLink={'/directory/provider/$providerId'}
      routeParams={{ providerId: provider._id }}
    >
      <VStack flex={1} alignItems={'start'} gap={'14px'} width={'100%'}>
        <VStack gap={'2px'} alignItems={'start'}>
          <Text variant={'urbanistExtraBoldSmall'} color={'text.mediumGray'}>
            ABOUT ME
          </Text>
          <Text
            height={'100%'}
            width={'100%'}
            whiteSpace={'pre-wrap'}
            variant={'urbanistSemiBoldRegular'}
            color={'text.mediumBlue'}
            noOfLines={3}
          >
            {provider.bio ?? 'No About Me'}
          </Text>
        </VStack>

        <VStack gap={'4px'} alignItems={'flex-start'}>
          <Text variant={'urbanistExtraBoldSmall'} color={'text.mediumGray'}>
            LOCATIONS
          </Text>
          <Text
            height={'100%'}
            width={'100%'}
            whiteSpace={'pre-wrap'}
            variant={'urbanistSemiBoldRegular'}
            color={'text.mediumBlue'}
            noOfLines={2}
          >
            {statesFormatted?.join(', ') || 'N/A'}
          </Text>
        </VStack>

        <VStack gap={'4px'} alignItems={'flex-start'}>
          <Text variant={'urbanistExtraBoldSmall'} color={'text.mediumGray'}>
            SPECIALIZATION
          </Text>
          <Text
            height={'100%'}
            width={'100%'}
            whiteSpace={'pre-wrap'}
            variant={'urbanistSemiBoldRegular'}
            color={'text.mediumBlue'}
            noOfLines={2}
          >
            {specializationsFormatted}
          </Text>
        </VStack>
        <VStack gap={'4px'} alignItems={'flex-start'}>
          <Text variant={'urbanistExtraBoldSmall'} color={'text.mediumGray'}>
            AVAILABILITY
          </Text>
          <Text
            height={'100%'}
            width={'100%'}
            whiteSpace={'pre-wrap'}
            variant={'urbanistSemiBoldRegular'}
            color={'text.mediumBlue'}
            noOfLines={1}
          >
            {availabilityFormatted}
          </Text>
        </VStack>
      </VStack>
      <RequestAProviderSessionModalTrigger
        triggerButtonTransparent
        triggerButtonWidth={ACTION_BUTTON_WIDTH}
        backgroundColor={colors.extra.white}
        noShadow
        hoveredBackgroundColor="white"
        hoveredLabelColor="primary.500"
        provider={{
          name: name,
          id: provider._id,
          designation: provider.designation,
          profilePhoto: provider.profile_photo ?? '',
        }}
      />
    </DirectoryCardBase>
  );
};

export default MYOProviderDirectoryCard;
